
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import CustomTagMixin from '@/@next/mixins/CustomTag';
import { CLazyLoadingImage } from '@/components/images';
import { CLoader } from '@/components/loader';
import CModal from '@/components/modal';
import { CImage } from '@/@next/components/image';
import { CButton } from '@/components/form-controls/button';
import _shuffle from 'lodash/shuffle';
import _cloneDeep from 'lodash/cloneDeep';
import Medias from '@/@next/services/Medias';
import { messages } from '@/@next/i18n';
import { TimelineContentData, TimelineContentEventData } from '@/@types/graphql';

const config = {
  name: 'c-timeline-full-screen-event',
  i18n: { messages },
  components: {
    CLazyLoadingImage,
    CLoader,
    CImage,
    ...CModal,
    CButton
  }
};

@Component(config)
export default class CTimelineFullScreenEvent extends Mixins(Medias) {
  @Prop({ type: Object, required: true }) event!: TimelineContentEventData;

  get date () {
    return this.event?.i18n?.date.value.html || null
  }

  get image ()  {
    return this.event.image
  }
  
  get text () {
    return this.event?.i18n?.text?.value.html || null
  }
}
